import React, { Component } from 'react'
import _ from 'lodash'
import JewelryPanel from '../jewelry-panel'
import Spacer from '../../../components/spacer'
import SelectItem from '../../../components/select-item'
import {showPrimaryMetalType} from '../../../utils/jewelry-validation'
import { metalTypes } from '../../../utils/format-labels'

class PrimaryMetalTypePanel extends Component {
  render () {
    const props = this.props
    const getMetalTypeOptions = () => {
      let metalTypeOptions = []
      _.forOwn(metalTypes, function (val, key) {
        metalTypeOptions.push({value: key, label: val})
      })
      return metalTypeOptions
    }

    return (
      <JewelryPanel
        id='primaryMetalTypePanel'
        show={showPrimaryMetalType(props)}
        isResetting={props.isResetting}>

        <Spacer xxs />

        <SelectItem
          id='primary_metal_type'
          label='Primary Metal'
          labelId='metaltype'
          options={getMetalTypeOptions()}
          value={props.primary_metal_type}
          onChange={props.onChangeVal.bind(this, 'primary_metal_type')}
          initVal={null}
        />
      </JewelryPanel>
    )
  }
}

export default PrimaryMetalTypePanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/primary-metal-type-panel/index.js